import React from 'react';
import styled from 'styled-components';
import { KPMGMainLogoWhiteIcon } from '../../assets/icons';
import background from '../../assets/images/background.png';
import ThreeDots from './ThreeDots';
const Background = styled.div `
  background-image: url(${background});
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100vh;
`;
const KPMGLogo = styled(KPMGMainLogoWhiteIcon) `
  width: 200px;
  height: 100px;
`;
const AppLoading = () => {
    return (<Background>
      <KPMGLogo />
      <ThreeDots />
    </Background>);
};
export default AppLoading;
